import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseState } from 'app/area/case/types-store';
import get from 'lodash/get';
import { StoreData, Entity } from 'app/types-shared';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { getAllEntitiesAtPath } from 'app/infrastructure/store';
import { entityValue } from 'app/infrastructure/store/entity';

export const requiredSearchFieldsFilled = (caseState: CaseState, uiEngineProps: ConnectedComponentProps) => {

  const requiredFieldsForSearch = get(uiEngineProps, 'componentDescriptor.properties.requiredFieldsForSearch') as string;

  if (!requiredFieldsForSearch) {
    return { requiredSearchFieldsFilled: true };
  }

  const dotNotationToEntityTypePath = (dotNotated: string) => dotNotated.split('.').slice(0, -1);
  const dotNotationToDataTag = (dotNotated: string) => dotNotated.split('.').slice(-1)[0];

  const allFieldsFilled = requiredFieldsForSearch.split(',').reduce((aggr, field) => {
    const entityTypePath = dotNotationToEntityTypePath(field);
    const dataTag = dotNotationToDataTag(field);

    const caseData: StoreData = getCaseData(caseState, uiEngineProps);
    const allEntities = getAllEntitiesAtPath(caseData, ['tblTrans', ...entityTypePath.slice(1)]);

    const valueFilled = (entity: Entity) => !!entityValue(entity, dataTag);

    return aggr && allEntities.reduce((a, c) => a || valueFilled(c), false);

  }, true);

  return { requiredSearchFieldsFilled: allFieldsFilled };
};
